function convertToStringVersion(version: string) {
    const splitReqex = /[.-]/
    return version
        .split(splitReqex)
        .map((v) => v.padStart(3, '0'))
        .join('')
}

class Version {
    version: string
    constructor(version: string) {
        this.version = convertToStringVersion(version)
    }

    isEqual(compareVersion: string) {
        return this.version === convertToStringVersion(compareVersion)
    }

    isOlder(compareVersion: string) {
        return this.version < convertToStringVersion(compareVersion)
    }
}

export default Version
